



























































import Vue, { PropType } from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
  name: "AlertBoxDialog",
  data() {
    return {
      dialog: true
    };
  },
  props: {
    title: {
      type: String as PropType<TranslateResult>,
      required: true
    },
    sub_title: {
      type: String as PropType<TranslateResult>
    },
    submit_btn_text: {
      type: String as PropType<TranslateResult>,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    color_code: {
      type: String,
      default: "#E32D6B"
    },
    icon: {
      type: String,
      default: "bold/trash.svg"
    },
    background_color: {
      type: String,
      default: "rgba(227, 45, 107, 0.1)"
    }
  },
  methods: {
    transform_del_icon(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("fill", this.color_code);
      return icon;
    }
  }
});
